import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { MarkupsService, PricePreview } from '@app/shared/services/markups/markups.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-price-preview',
  templateUrl: './price-preview.component.html',
  styleUrls: ['./price-preview.component.scss'],
})
export class PricePreviewComponent implements OnInit, OnChanges {
  @Input() price: string;
  @Input() propertyId: string;

  prices?: Array<any>;
  loading = false;
  updateDebouncer: Subject<any> = new Subject();

  constructor(private readonly markupsService: MarkupsService) {
    this.updateDebouncer.pipe(debounceTime(1000)).subscribe((notUsed) => {
      this.loadPrices();
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;
    this.prices = [];
    this.updateDebouncer.next(null);
  }

  loadPrices() {
    // Clear any current prices
    this.prices = [];

    // Start loading
    this.loading = true;

    // Fetch prices
    this.markupsService.getPerPlatformPricePreviews(this.propertyId, this.price).subscribe((res: PricePreview[]) => {
      // Set preview prices
      this.prices = res;

      // Stop loading
      this.loading = false;
    });
  }
}
